var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Vue } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { MockCaseLocalStorageImpl } from "../../../lib/utils/mockCaseManager";
/**
 * 挂在designer上 缓存当前的mock数据 负责沟通 mock按钮/modal 与 mock储存端/mockproxy插件之间的交互
 * */
let MockState = class MockState extends Vue {
  constructor() {
    super(...arguments);
    this.isMockOn = false;
    this.mockCaseUsed = '';
    /** 当前页面的全部mock数据 使用freeze仅保留浅层响应式 */
    this.mockList = [];
  }
  created() {
    // isMockOn由true变为false时自动关闭
    this.$watch(() => this.isMockOn, (newVal, oldVal) => {
      if (!newVal && oldVal) this.cancelMock();
    });
  }
  /** 按照uuid查找mock数据 */
  getMock(uuid) {
    return this.mockList.find(mockCase => mockCase.uuid === uuid);
  }
  /** 暂时mock数据存储到localstorage 之后拓展 */
  getMockCaseManager() {
    const manager = new MockCaseLocalStorageImpl();
    try {
      const {
        projectId,
        pageId
      } = this.wContext.config;
      manager.setWorkPage({
        projectId,
        pageId
      });
      return manager;
    } catch (e) {
      // 在playground里并没有wContext.config
      manager.setWorkPage({
        projectId: 'playground',
        pageId: 'playground'
      });
      return manager;
    }
  }
  /** 懒加载mock数据 */
  async getMockListOnce() {
    // 有缓存了就不用重新拉取了
    if (this.mockList.length) return this.mockList;
    return this.getMockList();
  }
  /** 全量拉取mock数据 */
  async getMockList() {
    const manager = this.getMockCaseManager();
    const mocklist = await manager.list();
    mocklist.reverse();
    // 避免不必要的更新
    mocklist.forEach(Object.freeze);
    this.$set(this, 'mockList', mocklist);
    return mocklist;
  }
  useMock(uuid) {
    if (!uuid) return this.cancelMock();
    const mockCase = this.getMock(uuid);
    if (!mockCase) return;
    this.uc.hooks.setMockState.call(true, mockCase, this.designer);
    this.isMockOn = true;
    this.mockCaseUsed = mockCase.uuid;
  }
  cancelMock() {
    this.uc.hooks.setMockState.call(false, null, this.designer);
    this.designer.mockState.isMockOn = false;
    this.mockCaseUsed = '';
  }
  async save(mockCaseString) {
    const mockCase = JSON.parse(mockCaseString);
    await this.getMockCaseManager().update(mockCase, mockCase.uuid);
    return this.getMockList();
  }
  async deleteMock(uuid) {
    var _this$getMock;
    // 删除时要检查是否被使用(虽说删了mock也能生效 已经是闭包进去了)
    if (this.isMockOn && ((_this$getMock = this.getMock(uuid)) === null || _this$getMock === void 0 ? void 0 : _this$getMock.uuid) === this.mockCaseUsed) {
      this.cancelMock();
    }
    await this.getMockCaseManager().delete(uuid);
    return this.getMockList();
  }
  async cloneMock(uuid) {
    await this.getMockCaseManager().create(this.getMock(uuid));
    return this.getMockList();
  }
  /** 从CRenderer里收集数据并存储 应用mock */
  async collectDesignerMock() {
    var _this$designer$rootRe;
    const designerMock = (_this$designer$rootRe = this.designer.rootRenderer) === null || _this$designer$rootRe === void 0 ? void 0 : _this$designer$rootRe.collectCRendererRuntimeData();
    if (!designerMock) return;
    designerMock.mockCaseName = 'designer临时数据';
    const newMockData = await this.getMockCaseManager().create(designerMock);
    await this.getMockList();
    this.mockCaseUsed = newMockData.uuid;
    // 先把ui刷出来然后再启动mock
    setTimeout(() => this.useMock(this.mockCaseUsed));
  }
  isChangedValue(uuid, newValue) {
    return newValue !== this.formatForMonaco(this.getMock(uuid));
  }
  /** monacoEditor展示时统一格式化 */
  formatForMonaco(value) {
    // 2是层级空格数量
    return JSON.stringify(value, null, 2);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], MockState.prototype, "designer", void 0);
__decorate([Inject({
  from: 'wContext',
  default: {}
})], MockState.prototype, "wContext", void 0);
__decorate([Inject(INJECT_UICORE_BUS)], MockState.prototype, "uc", void 0);
MockState = __decorate([Component({
  name: 'MockState'
})], MockState);
export default MockState;
//# sourceMappingURL=MockState.js.map
